export default __webpack_public_path__ + "static/media/product_1.e4480d19.svg";